import { render } from "./ServiceRequest.vue?vue&type=template&id=05a05310&ts=true"
import script from "./ServiceRequest.vue?vue&type=script&lang=ts"
export * from "./ServiceRequest.vue?vue&type=script&lang=ts"

import "./ServiceRequest.vue?vue&type=style&index=0&id=05a05310&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__